import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Subtitulo } from "@monorepo-web/components-library";
export default function BaseGrafico({ graphElement, titulo, alignTitleCenter, }) {
    return (_jsxs(_Fragment, { children: [titulo ? _jsx(Subtitulo, Object.assign({ mb: "8px", center: alignTitleCenter }, { children: titulo })) : null, graphElement] }));
}
